import { clsx } from "clsx";
import { EMPTY_DIAMOND_CLASSNAME } from "constants/globals";
import { LegendStatus } from "./LegendEnum";

type Props = {
  legendStatus: LegendStatus;
};

const LegendColor: React.FC<Props> = ({ legendStatus }) => {
  const key = Object.entries(LegendStatus).find(
    ([_, v]) => v === legendStatus
  )?.[0];
  if (!key) return null;
  if (legendStatus == LegendStatus.CAG || legendStatus == LegendStatus.PAL) {
    return (
      <div className={clsx("legend-color", key)}>
        <div className={EMPTY_DIAMOND_CLASSNAME} />
      </div>
    );
  }
  return <div className={clsx("legend-color", key)} />;
};

export default LegendColor;
